module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"card.recent_ticket.title":"Recent Tickets","card.progress_ticket.title":"Ticket ที่อยู่ระหว่างดำเนินการ","card.pending_ticket.title":"Pending Tickets","see_more.label":"ดูเพิ่ม","remark.description":"* แสดง 6 รายการล่าสุดเท่านั้น"}}')
  delete Component.options._Ctor
}
